import { 
  SendOtpRequest, 
  SendOtpResponse, 
  VerifyOtpRequest, 
  VerifyOtpResponse,
  SendRegistrationOtpRequest,
  VerifyRegistrationOtpRequest,
  SendLoginOtpRequest,
  VerifyLoginOtpRequest,
  AuthError 
} from '../dto/Auth.dto';

export class AuthService {
  private apiBaseUrl: string;

  constructor(apiBaseUrl: string) {
    this.apiBaseUrl = apiBaseUrl;
  }


  /**
   * Send OTP for unified authentication (handles both login and registration)
   */
  async sendUnifiedOtp(request: SendOtpRequest): Promise<SendOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/send-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Verify OTP for unified authentication (handles both login and registration)
   */
  async verifyUnifiedOtp(request: VerifyOtpRequest): Promise<VerifyOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Send OTP for registration
   */
  async sendRegistrationOtp(request: SendRegistrationOtpRequest): Promise<SendOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/send-registration-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Verify OTP and complete registration
   */
  async verifyRegistrationOtp(request: VerifyRegistrationOtpRequest): Promise<VerifyOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/verify-registration-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Send OTP for login
   */
  async sendLoginOtp(request: SendLoginOtpRequest): Promise<SendOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/send-login-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Verify OTP and login
   */
  async verifyLoginOtp(request: VerifyLoginOtpRequest): Promise<VerifyOtpResponse | AuthError> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/verify-login-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies for session management
        body: JSON.stringify(request),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  /**
   * Firebase login with ID token
   */
  async firebaseLogin(idToken: string): Promise<any> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/auth/firebase-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message: 'Network error. Please check your connection and try again.',
      };
    }
  }

  }
